
export default {
    name: 'choix-groupe-taxation',
    components: {},
    props: {
        groupes_taxation: Array,
        taxation_data: Object,
        taxation_togller: Number
    },
    data() {
        return {
            taxation: {
                group: '',
                taxe_specifique: ''
            }
        }
    },

    watch: {
        taxation_togller() {
            this.taxation.group = this.taxation_data.group_taxation
            this.taxation.taxe_specifique = this.taxation_data.taxe_specifique
            this.$refs.taxation_form.reset()
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        async handleTaxationApplcation() {
            const isValid = await this.$refs.taxation_form.validate();
            if (!isValid) {
                return;
            }

            const data = {
                group_taxation: this.taxation.group,
                taxe_specifique: (this.taxation.taxe_specifique != '' && this.taxation.taxe_specifique > 0)?parseInt(this.taxation.taxe_specifique):'',
                data_type: this.taxation_data.data_type,
                prestation: this.taxation_data.prestation,
                uid: this.taxation_data.uid,
                prix: this.taxation_data.prix,
                qte: this.taxation_data.qte,
                is_grouped: (this.taxation_data.is_grouped)?this.taxation_data.is_grouped:false,
                index: (this.taxation_data.index)?this.taxation_data.index:0
            }

            this.$emit('emitTaxation', data)
            this.$refs.grp_taxation.click()
        }
    }
}